<template>
    <div class="status-container" v-tippy="{ followCursor: true, placement: 'bottom-end' }" :content="rawStatus">
        <div class="status-circle" :class="statusClass"></div>
        <span class="status-text" :class="statusClass">
            {{ statusText }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'UnipileChannelStatusBadge',
    props: {
        channel: {
            type: Object,
            required: true
        }
    },
    computed: {
        rawStatus() {
            return this.$_.get(this.channel, "payload.sources.0.status", "WAITING");
        },
        statusText() {
            const statusTexts = {
                OK: "Bağlı",
                ERROR: "Bağlantı Kesildi",
                STOPPED: "Bağlantı Kesildi",
                CREDENTIALS: "Kimlik Doğrulama Gerekli",
                CONNECTING: "Bağlanıyor",
                DELETED: "Bağlantı Kesildi",
                CREATION_SUCCESS: "Bağlı",
                RECONNECTED: "Bağlı",
                SYNC_SUCCESS: "Bağlı",
                WAITING: "Kurulum Bekleniyor"
            };
            return statusTexts[this.rawStatus] || this.rawStatus;
        },
        statusClass() {
            const connectedStates = ["OK", "CREATION_SUCCESS", "RECONNECTED", "SYNC_SUCCESS"];
            const disconnectedStates = ["ERROR", "STOPPED", "DELETED"];
            
            if (connectedStates.includes(this.rawStatus)) return "status-ok";
            if (disconnectedStates.includes(this.rawStatus)) return "status-error";
            if (this.rawStatus === "CREDENTIALS") return "status-warning";
            if (this.rawStatus === "CONNECTING") return "status-connecting";
            return "status-waiting";
        }
    }
};
</script>

<style lang="scss" scoped>
.status-container {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .status-circle {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            top: -4px;
            left: -4px;
            right: -4px;
            bottom: -4px;
            border-radius: 50%;
            animation: pulse 2s infinite;
            opacity: 0.6;
        }
    }

    .status-text {
        font-size: 14px;
        font-weight: normal;
    }

    .status-ok {
        &.status-circle {
            background-color: #52c41a;
            &::after {
                border: 2px solid #52c41a;
            }
        }
        &.status-text {
            color: #52c41a;
        }
    }

    .status-error {
        &.status-circle {
            background-color: #ff4d4f;
            &::after {
                border: 2px solid #ff4d4f;
            }
        }
        &.status-text {
            color: #ff4d4f;
        }
    }

    .status-warning {
        &.status-circle {
            background-color: #faad14;
            &::after {
                border: 2px solid #faad14;
            }
        }
        &.status-text {
            color: #faad14;
        }
    }

    .status-connecting, .status-waiting {
        &.status-circle {
            background-color: #1890ff;
            &::after {
                border: 2px solid #1890ff;
            }
        }
        &.status-text {
            color: #1890ff;
        }
    }
}

@keyframes pulse {
    0% {
        transform: scale(0.8);
        opacity: 0.6;
    }
    70% {
        transform: scale(1.2);
        opacity: 0;
    }
    100% {
        transform: scale(0.8);
        opacity: 0;
    }
}
</style>
